var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgEndChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#757575",
  strokeLinecap: "round",
  strokeWidth: 1.24,
  d: "M5.237 2.35A6.831 6.831 0 0 0 7.83 15.5a6.83 6.83 0 0 0 2.592-13.15M7.83 1.5v6.488"
})));
export default SvgSvgEndChat;